import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PackageService from "services/PackageService";

export const getPackages = createAsyncThunk(
  "package/getPackages",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PackageService.getPackages(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadPackagesExcel = createAsyncThunk(
  "user/downloadPackagesExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await PackageService.downalodExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong"
      );
    }
  }
);
export const getSinglePackage = createAsyncThunk(
  "package/getSinglePackage",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PackageService.getSinglePackage(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const addPackage = createAsyncThunk(
  "package/addPackage",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await PackageService.addPackage(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add package"
      );
    }
  }
);

export const editPackage = createAsyncThunk(
  "package/editPackage",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await PackageService.editPackage(params, data);

      return response;
    } catch (err) {
      console.log("apires", err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editPackageStatus = createAsyncThunk(
  "package/editPackageStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await PackageService.editPackageStatus(data, status);
      return response;
    } catch (err) {
      console.log(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

const packageSlice = createSlice({
  name: "packages",
  initialState: {
    packages: {},
    singlePackage: {},
    loading: false,
    error: null,
    selectedPackageCategory: "standard",
  },
  reducers: {
    setSelectedPackageCategory: (state, action) => {
      state.selectedPackageCategory = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPackages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPackages.fulfilled, (state, action) => {
        state.loading = false;
        state.packages = action.payload;
      })
      .addCase(getPackages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadPackagesExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadPackagesExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadPackagesExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSinglePackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSinglePackage.fulfilled, (state, action) => {
        state.loading = false;
        state.singlePackage = action.payload;
      })
      .addCase(getSinglePackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addPackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPackage.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(addPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editPackage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPackage.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editPackage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editPackageStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPackageStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editPackageStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSelectedPackageCategory } = packageSlice.actions;
export default packageSlice.reducer;
